/** @param {unknown[]} list */
export function collectExchangeIds(list) {
  const exchangeIds = new Set()
  for (const msg of list) {
    if (msg && typeof msg === 'object' && typeof msg.exchangeId === 'string') {
      exchangeIds.add(msg.exchangeId)
    }
  }
  return exchangeIds
}
